import type { RouteRecordRaw } from 'vue-router';
import { BANNED_ROUTE_NAME, consumeBannedEntry, readBannedStateOf } from './utils';

const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

/**
 * Màn báo tài khoản bị khoá (STORY-921 Q3), thay `/auth/verify-required` đã xoá.
 *
 * **KHÔNG** `requireAuth`, khác hẳn màn nó thay thế. Lý do: tài khoản bị khoá không bao giờ giữ
 * được phiên hợp lệ — `signin` ném ngay, và `jwt.strategy` từ chối mọi request của user không
 * `active`, kể cả khi cache còn nóng. Đặt `requireAuth: true` ở đây là làm màn này không bao giờ
 * hiện được: guard sẽ đá về `/signin` trước khi nó kịp render.
 *
 * Người dùng tới đây từ nhánh lỗi của màn đăng nhập, mang theo dấu banned + email trong
 * `history.state` (`./utils.ts`). Không có email thì ô đó ẩn — không bịa.
 *
 * `beforeEnter` (#1181): màn này là KẾT QUẢ của một lần đăng nhập vừa bị từ chối, không phải trang
 * mở được bằng link — mở thẳng URL (kể cả khi đang đăng nhập bằng tài khoản active) thì về `/`, nơi
 * landing + `requireAuth` tự quyết tiếp. Hai lối vào hợp lệ, cần CẢ HAI:
 *   - màn đăng nhập vừa khởi phát (`goToBanned` trong `./utils.ts`) — lúc guard chạy vue-router CHƯA
 *     ghi state mới, nên chỉ đọc state là đá nhầm người vừa bị khoá;
 *   - tải lại / Back-Forward — entry `/banned` đã mang dấu banned (dấu gộp sang entry khác không tính).
 * Guard đồng bộ, không gọi mạng, không đụng tiệm — ngoại lệ có chủ đích của luật "không guard tiệm
 * trên route" (TASK-139, STRUCTURE.md §3).
 */
export const bannedRoutes = {
  name: BANNED_ROUTE_NAME,
  path: 'banned',
  beforeEnter: (to) => {
    // Luôn tiêu cờ trước — kể cả khi state đã đủ — để nó không sống sang lần điều hướng sau.
    const started = consumeBannedEntry();
    return started || readBannedStateOf(to.fullPath) !== null ? true : { path: '/', replace: true };
  },
  components: {
    default: () => import('./Banned.vue'),
    brand: () => import('./BannedBrand.vue'),
  },
  meta: {
    i18n,
    authHeader: {
      titleKey: 'banned.title',
      subtitleKey: 'banned.desc',
    },
  },
} satisfies RouteRecordRaw;
